import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import Loader from './Loader';
import { classNames } from './utils';
export default forwardRef(function Button({ variant = 'primary', size = 'normal', color = 'default', loading = false, disabled, onClick, children, icon, endIcon, className, }, ref) {
    var _a, _b;
    return (_jsx("button", { ref: ref, type: "button", disabled: disabled, onClick: (e) => (loading ? undefined : onClick === null || onClick === void 0 ? void 0 : onClick(e)), className: classNames((_a = { 'x-small': 'rounded-md', 'small': 'rounded-md' }[size]) !== null && _a !== void 0 ? _a : 'rounded-md', {
            'x-small': 'px-2',
            'small': 'px-2',
            'normal': 'px-2.5',
            'large': 'px-3',
            'x-large': 'px-3.5',
        }[size], {
            'x-small': 'py-1',
            'small': 'py-1',
            'normal': 'py-1.5',
            'large': 'py-2',
            'x-large': 'py-2.5',
        }[size], (_b = { 'x-small': 'text-xs' }[size]) !== null && _b !== void 0 ? _b : 'text-sm', 'font-semibold', 'focus-visible:outline-solid focus-visible:outline-2 focus-visible:outline-offset-2', {
            primary: 'text-white shadow-xs disabled:bg-gray-100 disabled:text-gray-400 disabled:ring-1 disabled:ring-inset disabled:ring-gray-200',
            secondary: 'bg-transparent ring-1 ring-inset',
            ternary: 'disabled:bg-transparent',
        }[variant], variant === 'primary'
            ? {
                default: 'bg-indigo-600 hover:bg-indigo-500 focus-visible:outline-indigo-600',
                primary: 'bg-indigo-600 hover:bg-indigo-500 focus-visible:outline-indigo-600',
                positive: 'bg-emerald-600 hover:bg-emerald-500 focus-visible:outline-emerald-600',
                negative: 'bg-red-600 hover:bg-red-500 focus-visible:outline-red-600',
                white: 'bg-white text-gray-900 ring-gray-300 hover:bg-gray-100 focus-visible:outline-gray-300',
            }[color]
            : '', variant === 'secondary'
            ? {
                default: 'text-gray-700 ring-gray-300 hover:bg-gray-100 disabled:bg-gray-100 disabled:text-gray-400 disabled:ring-gray-200',
                primary: 'text-indigo-600 ring-indigo-500 hover:bg-indigo-50 disabled:bg-indigo-50 disabled:text-indigo-300 disabled:ring-indigo-100',
                positive: 'text-emerald-600 ring-emerald-600 hover:bg-emerald-50 disabled:bg-emerald-50 disabled:text-emerald-300 disabled:ring-emerald-100',
                negative: 'text-red-500 ring-red-500 hover:bg-red-50 disabled:bg-red-50 disabled:text-red-300 disabled:ring-red-100',
                white: 'text-gray-900 ring-gray-300 hover:bg-gray-100 disabled:bg-gray-100 disabled:text-gray-400 disabled:ring-gray-200',
            }[color]
            : '', variant === 'ternary'
            ? {
                default: 'text-gray-900 hover:bg-gray-50 disabled:text-gray-400',
                primary: 'text-indigo-600 hover:bg-indigo-50 disabled:text-indigo-300',
                positive: 'text-emerald-600 hover:bg-emerald-50 disabled:text-emerald-300',
                negative: 'text-red-600 hover:bg-red-50 disabled:text-red-300',
                white: 'text-white hover:bg-gray-500 disabled:text-gray-400',
            }[color]
            : '', 'inline-flex items-center justify-center gap-x-1.5', className), children: !loading ? (_jsxs(_Fragment, { children: [icon ? _jsx("div", { children: icon }) : _jsx(_Fragment, {}), children, endIcon ? _jsx("div", { children: endIcon }) : _jsx(_Fragment, {})] })) : (_jsxs("div", { className: "relative", children: [_jsx("div", { className: "pointer-events-none opacity-0", children: children }), _jsx("div", { className: "absolute bottom-0 left-0 right-0 top-0 flex items-center justify-center", children: _jsx(Loader, { size: 4 }) })] })) }));
});
